import Api from "../../../api";

import { PlaceCategory } from "./models"

const iconUrl = "/icon";

class CategoryApi extends Api {
	
	get(descriptor, tree, callback) {
		var url = this.baseUrl;

		this.client.get(url, { params: { category: descriptor, tree: tree } })
			.then((response) => {
				callback({
					result: new PlaceCategory(response.data),
					error: null
				});
			}).catch((error) => {
				callback({ 
		    		result: null, 
		    		error: this.extractError(error)
		    	});
			});
	}	

	getAll(callback) {
		var url = this.baseUrl;

		this.client.get(url)
			.then((response) => {
				var data = [];
				for (var index = 0; index < response.data.length; index++) {
					data.push(new PlaceCategory(response.data[index]));
				}

				callback({
					result: data,
					error: null
				});
			}).catch((error) => {
				callback({ 
		    		result: null, 
		    		error: this.extractError(error)
		    	});
			});
	}	

	update(category, callback) {
		var url = this.baseUrl + "/" + category.id;

		this.client.put(url, category)
			.then((response) => {
				callback({
					result: new PlaceCategory(response.data),
					error: null
				});
			}).catch((error) => {
				callback({ 
		    		result: null, 
		    		error: this.extractError(error)
		    	});
			});
	}

	create(category, callback) {
		var url = this.baseUrl

		this.client.post(url, category)
			.then((response) => {
				callback({
					result: new PlaceCategory(response.data),
					error: null
				});
			}).catch((error) => {
				callback({ 
		    		result: null, 
		    		error: this.extractError(error)
		    	});
			});
	}

	delete(categoryId, callback) {
		var url = this.baseUrl + "/" + categoryId;

		this.client.delete(url)
			.then((response) => {
				callback({
					result: response.data,
					error: null
				});
			}).catch((error) => {
				callback({ 
		    		result: null, 
		    		error: this.extractError(error)
		    	});
			});
	}


	getIconUrl(categoryId) {
		return this.baseUrl + "/" + categoryId + iconUrl;
	}


};


export default CategoryApi;